import Link from 'next/link';
import React from 'react';
import { isSafari } from '../../../utils/helpers/utils';
import { OptimizedImage } from '../../common';

/**
 * Header Brand Component
 * Displays the company logo
 * 
 * @param {String} logoUrl - Logo image URL
 * @param {String} alternativeText - Logo alt text
 * @param {Boolean} isMobile - Whether this is for mobile layout
 * @param {String} className - Additional CSS classes
 */
const HeaderBrand = ({ logoUrl, alternativeText, isMobile = false, className = '' }) => {
    return (
        <Link href="/" className={`navbar-brand ${isMobile ? 'me-0 mt-1' : ''} ${className}`}>
            <OptimizedImage 
                src={logoUrl} 
                alt={alternativeText} 
                width={125} 
                height={60} 
                style={{ 
                    objectFit: 'scale-down',
                    ...(isMobile ? {} : { height: '60px', width: '125px !important' })
                }} 
                priority={true}
                quality={85}
                sizes="125px"
            />
        </Link>
    );
};

export default HeaderBrand;
